import React, { Component } from "react";
import AuthService from "../../Auth/AuthService";
import PermissionFeature from "../../Permissions/PermissionFeature";
import { connect } from "react-redux";
import actionFilter from "../../../store/facility/action";
import actionActivity from "../../../store/activitylogging/action";
import { Collapse, Spinner, Col } from "reactstrap";
import AuditModuleTypes from "../../Shared/AuditModuleTypes";

import Users from "../../Admin/Users/Users";
import NCEPT from "./NCEPT";
import Finance from "./Finance";
import TrafficCount from "./TrafficCount";
import OSHA from "./OSHA";
import OWCP from "./OWCP";
import Legislative from "./Legislative";
import Maps from "./Maps";
import Assets from "./Assets";
import TrainedActivists from "./TrainedActivists";
import Grievaneces from "./Grievaneces";
import _ from "lodash";
import Tree from "./Tree/Tree";

import ActivityLogging from "../../../../src/modules/Shared/ActivityLogging";
import EquipmentsCardList from "../../Admin/Users/EditUser/EquipmentsCardList";
import FE_Equipment_Card_Types from "../../F&E/FE_Equipment_Card_Types";
export class FacilityCategories extends Component {
  constructor(props) {
    super(props);

    this.DEBUG = process.env.NODE_ENV === "development";
    if (this.DEBUG) {
    }
  }

  componentDidMount() { }

  onFilesAccordionClick = (fileid) => {
    if (this.props.facilityDashboardState.facilityActiveTab !== 1) {
      this.props.getFacilityFiles(this.props.facilityId);
      this.props.setFacilityActiveTab(fileid);
    } else if (this.props.facilityDashboardState.facilityActiveTab === 1) {
      this.props.setFacilityActiveTab(0);
    }
  };

  onAccordionClick = (id) => {
    let currentSelectedItem = this.props.facilityDashboardState
      .facilityActiveTab;

    if (currentSelectedItem !== id) {
      if (id === 10) {
        /// Maps
        this.props.getSelectedMapsForFacility(this.props.facilityId);
      }

      if (id === 13) {
        /// ActivityLogging

        this.props.resetLogs();
        this.props.getActicityLoggingByModuleId(
          AuditModuleTypes.Facility,
          this.props.facilityId,
          0,
          10
        );
      }

      this.props.setFacilityActiveTab(id);
    } else if (currentSelectedItem === id) {
      this.props.setFacilityActiveTab(0);
    }
  };

  render() {
    let currentActiveTab = this.props.facilityDashboardState.facilityActiveTab;
    //debugger;
    return (
      <Col className="facilityCategoriesList">
        {AuthService.canFacilityView(PermissionFeature.FacilityFiles) ? (
          <div>
            <div
              className={
                currentActiveTab === 1
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onFilesAccordionClick(1)}
            >
              <a className="font-italic">Files</a>

              <i
                className={
                  currentActiveTab === 1
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab === 1}>
              {!this.props.facilityDashboardState.IsFilesTreeLoading && (
                <Tree facilityId={this.props.facilityId} />
              )}

              {this.props.facilityDashboardState.IsFilesTreeLoading && (
                <div className="row spinnerFacilityCategory">
                  <Spinner />
                </div>
              )}
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.FacilityMembers) ? (
          <div>
            <div
              className={
                currentActiveTab === 2
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(2)}
            >
              <a className="font-italic">Members</a>

              <i
                className={
                  currentActiveTab === 2
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab == 2}>
              {this.props.facility && currentActiveTab === 2 && (
                <Users
                  his={this.props.his}
                  isFacility={true}
                  isPAC={false}
                  facility={this.props.facility}
                  FacilityDashboard={true}
                  FacilityMembers={true}
                  facilityId={this.props.facilityId}
                />
              )}

              {this.props.facilityDashboardState.IsMemberAccordianLoading && (
                <div className="row spinnerFacilityCategory">
                  <Spinner />
                </div>
              )}
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.FacilityGrievances) ? (
          <div>
            <div
              className={
                currentActiveTab === 3
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(3)}
            >
              <a className="font-italic">Grievances</a>

              <i
                className={
                  currentActiveTab === 3
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab == 3}>
              <Grievaneces />
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.PacMembers) ||
          AuthService.canFacilityView(PermissionFeature.PacSummary) ? (
          <div>
            <div
              className={
                currentActiveTab === 4
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(4)}
            >
              <a className="font-italic">PAC</a>
              <i
                className={
                  currentActiveTab === 4
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab === 4}>
              <div className="accordianContainerBorder">
                {AuthService.canFacilityView(PermissionFeature.PacMembers) &&
                  this.props.facility && (
                    <Users
                      his={this.props.his}
                      isFacility={true}
                      isPAC={true}
                      facility={this.props.facility}
                      FacilityDashboard={true}
                      PACMembers={true}
                    />
                  )}

                {this.props.facilityDashboardState.IsMemberAccordianLoading && (
                  <div className="row spinnerFacilityCategory">
                    <Spinner />
                  </div>
                )}
              </div>
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(
          PermissionFeature.FacilityNceptStaffing
        ) ? (
          <div>
            <div
              className={
                currentActiveTab === 5
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(5)}
            >
              <a className="font-italic">NCEPT/Staffing </a>
              <span>Visit <a target="_blank" href="https://www.natca.org/ncept/"><b>NATCA.org/NCEPT </b></a>for more information on the NCEPT process</span>
              <i
                className={
                  currentActiveTab === 5
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab == 5}>
              <NCEPT facilityId={this.props.facilityId} />

              {/* <h5>NCEPT</h5> */}
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.Finance) ? (
          <div>
            <div
              className={
                currentActiveTab === 15
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(15)}
            >
              <a className="font-italic">Finance</a>
              <i
                className={
                  currentActiveTab === 15
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab == 15}>
              <Finance facilityId={this.props.facilityId} />

              {/* <h5>NCEPT</h5> */}
            </Collapse>
          </div>
        ) : null}
        {AuthService.canFacilityView(PermissionFeature.FacilityTrafficCount) ? (
          <div>
            <div
              className={
                currentActiveTab === 6
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(6)}
            >
              <a className="font-italic"> Traffic Count</a>

              <i
                className={
                  currentActiveTab === 6
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab == 6}>
              <TrafficCount />
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.FacilityOsha) ? (
          <div>
            <div
              className={
                currentActiveTab === 7
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(7)}
            >
              <a className="font-italic">OSHA</a>

              <i
                className={
                  currentActiveTab === 7
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab == 7}>
              <OSHA facilityId={this.props.facilityId} />
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.FacilityOwcp) ? (
          <div>
            <div
              className={
                currentActiveTab === 8
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(8)}
            >
              <a className="font-italic">OWCP</a>
              <i
                className={
                  currentActiveTab === 8
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab === 8}>
              <OWCP />
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.FacilityLegislative) ? (
          <div>
            <div
              className={
                currentActiveTab === 9
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(9)}
            >
              <a className="font-italic">Legislative</a>
              <i
                className={
                  currentActiveTab === 9
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse isOpen={currentActiveTab === 9}>
              <Legislative />
            </Collapse>
          </div>
        ) : null}

        {AuthService.canFacilityView(PermissionFeature.FacilityMaps) ? (
          <div>
            <div
              className={
                currentActiveTab === 10
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(10)}
            >
              <a className="font-italic">Maps</a>

              <i
                className={
                  currentActiveTab === 10
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              />
            </div>

            <Collapse
              isOpen={currentActiveTab === 10}
              className="accordianContainerBorder facilityAccordianHeight"
            >
              {!this.props.facilityDashboardState.isAccordionLoading && (
                <Maps facilityId={this.props.facilityId} />
              )}
              {this.props.facilityDashboardState.isAccordionLoading && (
                <div className="row spinnerFacilityCategory">
                  <Spinner />
                </div>
              )}
            </Collapse>
          </div>
        ) : null}
        {/* {AuthService.canFacilityView(PermissionFeature.FacilityAssets) && (
          <div>
            <div
              className={
                currentActiveTab === 14
                  ? "facilityCollapsBtn"
                  : "facilityTabSection"
              }
              onClick={() => this.onAccordionClick(14)}
            >
              <a className="font-italic">Equipment</a>

              <i
                className={
                  currentActiveTab === 14
                    ? "fas arrow-icon fa-chevron-down"
                    : "fas arrow-icon fa-chevron-up"
                }
              ></i>
            </div>

            <Collapse isOpen={currentActiveTab == 14}>
              <EquipmentsCardList
                recordId={this.props.facilityId}
                tableType={FE_Equipment_Card_Types.Facility}
              />
            </Collapse>
          </div>
        )} */}
        {AuthService.canFacilityView(
          PermissionFeature.FacilityTrainedActivists
        ) && (
            <div>
              <div
                className={
                  currentActiveTab === 12
                    ? "facilityCollapsBtn"
                    : "facilityTabSection"
                }
                onClick={() => this.onAccordionClick(12)}
              >
                <a className="font-italic">Trained Activists</a>

                <i
                  className={
                    currentActiveTab === 12
                      ? "fas arrow-icon fa-chevron-down"
                      : "fas arrow-icon fa-chevron-up"
                  }
                />
              </div>

              <Collapse isOpen={currentActiveTab == 12}>
                {/* <TrainedActivists /> */}
                {/* <Files /> */}
              </Collapse>
            </div>
          )}

        {AuthService.canFacilityView(
          PermissionFeature.FacilityActivityLogs
        ) && (
            <div>
              <div
                className={
                  currentActiveTab === 13
                    ? "facilityCollapsBtn"
                    : "facilityTabSection"
                }
                onClick={() => this.onAccordionClick(13)}
              >
                <a className="font-italic">Activity Logging</a>

                <i
                  className={
                    currentActiveTab === 13
                      ? "fas arrow-icon fa-chevron-down"
                      : "fas arrow-icon fa-chevron-up"
                  }
                />
              </div>

              <Collapse isOpen={currentActiveTab == 13}>
                <ActivityLogging recordId={this.props.facilityId} />
              </Collapse>
            </div>
          )}
      </Col>
    );
  }
}
export default connect(
  (state) => ({ facilityDashboardState: state.facilityDashboard }),
  {
    ...actionFilter,
    ...actionActivity,
  }
)(FacilityCategories);
